import React from 'react';
import { DateUnitPickerCompat as DateUnitPickerCompatNew } from './DateUnitPickerCompat';
import { convertOldDateUnitPickerProps, OldDateUnitPickerProps } from './converter.old';

export type DateUnitPickerProps = OldDateUnitPickerProps;
export type DateUnitPickerCompatProps = DateUnitPickerProps;
export const DateUnitPickerCompat: React.FC<DateUnitPickerProps> = (props) => (
  <DateUnitPickerCompatNew {...convertOldDateUnitPickerProps(props)} />
);
export const DateUnitPicker = DateUnitPickerCompat;
